module.exports = __webpack_public_path__ + "media/goforajourney/img/mexico-city-tour-d1532cefa9c65630e45eb609c27b0e6d.jpg";